import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import {request} from '../containers/actions';
import Dialog from '../dialog/dialog';
import * as styles from '../styles';
import {close} from '../dialog/actions';

export default class WelcomeDialog extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (this.props.user.type && this.props.user.type.length)
            this.updateContent.bind(this)();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.user.type, this.props.user.type) && this.props.user.type && this.props.user.type.length) {
            this.updateContent.bind(this)();
        }
    }

    async updateContent() {
        const response = await this.context.store.dispatch(request({
            path: '/content/get/',
            body: {uri: '/' + this.props.user.type[0] + '_welcome'},
        }));
        if (!response.published)
            this.context.store.dispatch(close(this.props.elementId));
        this.setState({content: response.content});
    }

    render() {
        return <Dialog {...this.props}>
            <div>
                <div
                    style={{
                        marginTop: '-1em',
                        // maxWidth: '17cm',
                        width:'100%',
                        display: 'block',
                    }}
                    dangerouslySetInnerHTML={{__html: this.state.content}}
                />
                <button
                    style={{...styles.defaultButton, float: 'left'}}
                    onClick={() => this.context.store.dispatch(close(this.props.elementId))}>
                    {window.gettext('OK')}
                </button>
            </div>
        </Dialog>;
    }
};
